import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    videoId: String,
    title: String,
  }

  connect() {
    if (window.__youtubeConsentGranted) {
      this._loadIframe()
      return
    }
    window.addEventListener("youtube:consent-granted", this._onConsent)
  }

  disconnect() {
    window.removeEventListener("youtube:consent-granted", this._onConsent)
  }

  play() {
    if (window.__youtubeConsentGranted) {
      this._loadIframe()
    } else {
      this.element.querySelector("[data-notice]")?.classList.remove("hidden")
    }
  }

  _onConsent = () => {
    this._loadIframe()
  }

  _loadIframe() {
    const iframe = document.createElement("iframe")
    iframe.src = `https://www.youtube-nocookie.com/embed/${this.videoIdValue}?rel=0&modestbranding=1&autoplay=1`
    iframe.title = this.titleValue
    iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    iframe.allowFullscreen = true
    iframe.className = "absolute inset-0 w-full h-full"
    this.element.replaceWith(iframe)
  }
}
